import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput } from "@/graphql/codegen/graphql"
import useProductCategory from "@/screens/ManageProducts/components/ProductCategories/hooks/useProductCategory"

interface CategoryFilterChipsProps {
  selectedCategory?: string
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
}

const CategoryFilterChips: React.FC<CategoryFilterChipsProps> = ({ selectedCategory, onRemove }) => {
  const { productCategoryList } = useProductCategory({ query: "", categoryId: selectedCategory })

  const categoryName = useMemo(
    () => productCategoryList.find((category) => category.categoryId === selectedCategory)?.name ?? "",
    [selectedCategory, productCategoryList]
  )

  return (
    <FilterChip
      key={`price-change-category-filter-chip`}
      label={`Category: ${categoryName}`}
      onDelete={() => onRemove("productCategoryId", undefined)}
    />
  )
}

export default CategoryFilterChips
